import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=digitalCard；菜单根路径 /digital-card */
export const digitalCardModule: AiAppCenterModule = {
  key: 'digitalCard',
  label: '微名片',
  desc: '名片审核 / 实名企认审核 / 品牌模板 / 批量开通 / 数据看板',
  path: '/digital-card',
  homePath: '/digital-card/manage',
  icon: 'ep:postcard',
  color: '#c89e62',
  aliases: ['数字名片', '微名片']
}
